import './Events.css';

export function Events() {

    return (
        <div className="events-container">
            <h5>Egyelőre nincsenek események!</h5>
        </div>
    );
}